import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Stats from "@/components/landing/Stats";
import WhyAxiom from "@/components/landing/WhyAxiom";
import Process from "@/components/landing/Process";
import Pricing from "@/components/landing/Pricing";
import Urgency from "@/components/landing/Urgency";
import Testimonials from "@/components/landing/Testimonials";
import FAQ from "@/components/landing/FAQ";
import LeadCapture from "@/components/landing/LeadCapture";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="bg-ink text-white min-h-screen">
      <Nav />
      <main>
        <Hero />
        <Stats />
        <WhyAxiom />
        <Process />
        <Urgency />
        <Pricing />
        <Testimonials />
        <FAQ />
        <LeadCapture />
      </main>
      <Footer />
    </div>
  );
}
